// extracted by mini-css-extract-plugin
export default {"someLinks":"Footer_someLinks__N3TAT","copyright":"Footer_copyright__JQMtz","night":"Footer_night__tji80","contact":"Footer_contact__WmEl1"};